module.exports = __webpack_public_path__ + "static/media/scrollDown-offCanvas.298b1450.gif";